
import React, { useState, useEffect, Fragment, useRef, useCallback } from 'react'
import {
  Select, Form, Input, Button, Modal, Table, Typography, Popconfirm,
  Upload, Row, Col, Switch, message, InputNumber, Space, Radio, TreeSelect, Tree
} from "antd";
import { PlusSquareOutlined, MinusSquareOutlined, EditFilled, DeleteOutlined } from '@ant-design/icons';
// import { LoadingOutlined, PlusOutlined, MinusCircleOutlined } from '@ant-design/icons';
// import HandleButton from "@/components/HandleButton"
import RoleApi from '@api/role'
import update from 'immutability-helper';
// import { DndProvider, useDrag, useDrop } from 'react-dnd';
// import { HTML5Backend } from 'react-dnd-html5-backend';

import ResourceApi from '@api/resource'
// import Title from '@/components/Title'
// import MinTitle from '@/components/MinTitle'
// import MessageApi from '@api/message'
import AddModal from '@components/Modal'
import moment from 'moment';
// const { UPLOADER } = window.globalConfig;
import { alarmApi, stationApi, dictApi } from "@api/newApi";
import InspectionApi from '@api/inspection'
import { treeConversion, treeIds, extraIds, cycleData } from '@utils/common'
const layout = {
  labelCol: { span: 3 },
  wrapperCol: { span: 21 },
};
const { SHOW_PARENT, SHOW_ALL, TreeNode } = TreeSelect;
const Option = Select.Option
const type = 'DraggableBodyRow';
// 行
const DraggableBodyRow = ({ index, moveRow, className, style, ...restProps }) => {
  const ref = useRef(null);
  const [{ isOver, dropClassName }, drop] = useDrop({
    accept: type,
    collect: (monitor) => {
      const { index: dragIndex } = monitor.getItem() || {};

      if (dragIndex === index) {
        return {};
      }

      return {
        isOver: monitor.isOver(),
        dropClassName: dragIndex < index ? ' drop-over-downward' : ' drop-over-upward',
      };
    },
    drop: (item) => {
      moveRow(item.index, index);
    },
  });
  const [, drag] = useDrag({
    type,
    item: {
      index,
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });
  drop(drag(ref));
  return (
    <tr
      ref={ref}
      className={`${className}${isOver ? dropClassName : ''}`}
      style={{
        cursor: 'move',
        ...style,
      }}
      {...restProps}
    />
  );
};
// 单元格
const EditableCell = ({ editing, dataIndex, title, inputType, record, index, children, isEdit, ...restProps }) => {
  const inputNode = inputType === 'number' ? <InputNumber /> : <Input disabled={dataIndex === 'name' && !isEdit} />;
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{
            margin: 0,
          }}
          rules={[
            {
              required: true,
              message: `请输入${title}!`,
            },
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};


let childIds = ''
export default () => {
  const [form] = Form.useForm();
  const [formTable] = Form.useForm();
  const [editBool, setEditBool] = useState(false)
  const [formValue, setFormValue] = useState()
  const [loading, setLoading] = useState()

  const [contentData, SetContentData] = useState([{ name: '点点滴滴', name1: true, name2: false }])


  const columns = [
    {
      title: '巡检项',
      dataIndex: 'name',
      key: 'name',
      editable: true,
    },
    {
      title: '安全隐患/运行状态',
      dataIndex: 'age',
      key: 'age',
      editable: true,
    },
    {
      title: '关联设备',
      dataIndex: 'name1',
      key: 'name1',
      editable: true,
    },
    {
      title: '单位',
      dataIndex: 'name2',
      key: 'name2',
      editable: true,
    },
    {
      title: '限制区间',
      dataIndex: 'name3',
      key: 'name3',
      editable: true,
    },
    {
      title: '缺陷等级',
      dataIndex: 'name4',
      key: 'name4',
      editable: true,
    },
    {
      title: '是否拍照',
      dataIndex: 'name5',
      key: 'name5',
      editable: true,
    },
    {
      title: '操作',
      dataIndex: 'operation',
      render: (_, record, index) => {
        const editable = isEditing(record);
        return editable ? (
          <span>
            <Typography.Link
              onClick={() => save(record.key)}
              style={{
                marginRight: 8,
              }}
            >
              保持
            </Typography.Link>
            <Popconfirm title="Sure to cancel?" onConfirm={cancel}>
              <a>取消</a>
            </Popconfirm>
          </span>
        ) : (
          <>
            <Typography.Link disabled={editingKey !== '' || record.disabled} onClick={() => edit(record)}>
              编辑
            </Typography.Link>
            <Typography.Link style={{ marginLeft: '10px' }} disabled={editingKey !== ''} onClick={() => updateData(record, index)}>
              {!record.disabled ? '禁用' : '启用'}
            </Typography.Link>
          </>
        );
      },
    },
  ];
  const updateData = (record, i) => {
    const tt = [...data]
    tt[i].disabled = tt[i].disabled ? false : true
    setData(tt)
  }

  // 提交
  const submit = () => {
    form.validateFields().then(values => {
      if (!values) {
        return
      }
      setLoading(true)
      let param = {
        ...values,
      }
      InspectionApi.add(param, { headers: { deptPath: values.deptPath } }).then(res => {
        if (res.status == 0) {
          message.success('新建成功')
          handelCancel(true)
        }
        setLoading(false)
      }).catch((err) => {
        setLoading(false)
      })
    })
  }
  // 取消
  const handelCancel = (bool = false) => {
    form.resetFields();
    cancel(bool);
  }


  const [data, setData] = useState([
    {
      key: '1',
      name: 'John Brown',
      age: 32,
      address: '12',
      name1: '123',
      name2: '123',
      name3: '123',
      name4: '123',
      name5: '123',
    },
    {
      key: '2',
      name: 'Jim Green',
      age: 42,
      address: 'London No. 1 Lake Park',
      name1: '123',
      name2: '123',
      name3: '123',
      name4: '123',
      name5: '123',
    },
    {
      key: '3',
      name: 'Joe Black',
      age: 32,
      address: 'Sidney No. 1 Lake Park',
      name1: '123',
      name2: '123',
      name3: '123',
      name4: '123',
      name5: '123',
    },
  ]);
  const components = {
    body: {
      row: DraggableBodyRow,
      cell: EditableCell,
    },
  };
  const moveRow = useCallback(
    (dragIndex, hoverIndex) => {
      const dragRow = data[dragIndex];
      setData(
        update(data, {
          $splice: [
            [dragIndex, 1],
            [hoverIndex, 0, dragRow],
          ],
        }),
      );
    },
    [data],
  );
  const [editingKey, setEditingKey] = useState('');

  const isEditing = (record) => record.key === editingKey;

  const edit = (record) => {
    formTable.setFieldsValue({
      name: '',
      age: '',
      address: '',
      ...record,
    });
    setEditingKey(record.key);
  };
  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: col.dataIndex === 'age' ? 'number' : 'text',
        dataIndex: col.dataIndex,
        title: col.title,
        disabled: record.disabled,
        // isEdit: col.key.includes('add'),
        editing: isEditing(record),
      }),
    };
  });

  const cancel = () => {
    setEditingKey('');
  };
  const addItem = () => {
    const add = {
      key: "add" + data.length,
      name: '',
      age: '',
      address: '',
      name1: '',
      name2: '',
      name3: '',
      name4: '',
      name5: '',
    }
    const newData = [...data, add];
    setData(newData);
    edit(add)
  }
  const save = async (key) => {
    try {
      const row = await formTable.validateFields();
      const newData = [...data];
      const index = newData.findIndex((item) => key === item.key);

      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, { ...item, ...row });
        setData(newData);
        setEditingKey('');
      } else {
        newData.push(row);
        setData(newData);
        setEditingKey('');
      }
    } catch (errInfo) {
      console.log('Validate Failed:', errInfo);
    }
  };

  return (
    // <AddModal title={title} footer={[
    //   <Row key={'btn'} span={24}>
    //     <Button key={1} onClick={handelCancel} className='abuttons'>
    //       <i className='iconfont iconfanhui'>
    //       </i>&nbsp;&nbsp;取消
    //     </Button>
    //     <Button key={2} loading={loading} onClick={submit} className='abuttons' type="primary">
    //       <i className='iconfont iconbaocun'>
    //       </i>&nbsp;&nbsp;保存
    //     </Button>
    //   </Row>]
    // } visible={visible} width={800} okText={'确定'} onCancel={handelCancel} onSubmit={() => submit()}>
    <div className='baseContent boundary' style={{ display: 'flex', flexFlow: "column" }}>
      <div className='title' style={{ padding: '20px', flex: 1 }}>
        <Form
          {...layout}
          layout="horizontal"
          form={form}
        >
          {/* <Row> */}
          <Col span={24}>
            <Form.Item
              label='模版名称'
              name="templateName"
              rules={[{ required: true, message: '请输入资源名称!' }]}
            >
              <Input disabled={editBool} style={{ width: '200px' }} placeholder={'请输入资源名称'} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label='场站名称'
              name="templateName"
              rules={[{ required: true, message: '请输入资源名称!' }]}
            >
              <Input disabled={editBool} style={{ width: '200px' }} placeholder={'请输入资源名称'} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label='巡检模版'
              name="templateName"
              rules={[{ required: true, message: '请输入资源名称!' }]}
            >
              <Input disabled={editBool} style={{ width: '200px' }} placeholder={'请输入资源名称'} />
            </Form.Item>
          </Col>
          {/* <Col span={24}>
            <Form.Item
              label='模版内容'
              name="content"
            >
              {num && contentData.map((v, i) => {
                return (
                  <Row key={'row' + i + v.name} style={{ marginBottom: '10px' }}>
                    <Col span={20} style={{ display: 'flex', alignItems: 'center' }}>
                      <Input defaultValue={contentData[i].name} style={{ width: '200px' }} onBlur={(e) => setDataAttr(i, 'name', e.target.value)} placeholder={'巡检内容'} />
                      <Col style={{ margin: '0 20px' }}>
                        <span>安全隐患：</span><Switch checked={v.name1} onChange={(e) => setDataAttr(i, 'name1', e)} checkedChildren="是" unCheckedChildren="否" />
                      </Col>
                      <Col>
                        <span>运行状态：</span><Switch checked={v.name2} onChange={(e) => setDataAttr(i, 'name2', e)} checkedChildren="运行" unCheckedChildren="热备" />
                      </Col>
                    </Col>
                    <Col span={4} style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }} >
                      <PlusSquareOutlined onClick={() => addContent(i)} style={{ fontSize: '24px', color: '#2D99FF', marginLeft: '20px' }} />
                      {(num > 1) && < MinusSquareOutlined onClick={() => delContent(i)} style={{ fontSize: '24px', color: '#2D99FF' }} />}
                    </Col>
                  </Row>
                )
              }) || null}
            </Form.Item>
          </Col> */}
        </Form>
        {/* <Form form={formTable} component={false}>
          <DndProvider backend={HTML5Backend}>
            <Table
              columns={mergedColumns}
              dataSource={data}
              components={components}
              footer={() => {
                return (
                  <Button onClick={addItem}>新增</Button>
                )
              }}
              pagination={false}
              onRow={(_, index) => {
                const attr = {
                  index,
                  moveRow,
                };
                return attr;
              }}
            />
          </DndProvider>
        </Form> */}
      </div>
    </div>
  )

}
